// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"231c61a4","575":"680d0ad0"}[chunkId] + ".chunk.css";
};